/* medina-mobile-fixes.js · Medina Menswear · 2026-10-06
   1) Mide la barra inferior visible (sticky ATC / "Finalizar compra" del carrito)
      y expone --m-bottom-bar-h + clase html.m-bottom-bar-on (la usa el CSS para
      subir el chat de Shopify Inbox, el banner de cookies y el teaser de Klaviyo).
   2) Sincroniza el selector de talla de la barra sticky con los chips de talla
      de la ficha (antes: elegir talla en la barra NO habilitaba el botón y
      "Añadir al carrito" solo hacía scroll hacia arriba).                      */
(function () {
  var root = document.documentElement;
  root.classList.add('m-mf-js');
  var mq = window.matchMedia('(max-width: 767px)');

  function bars() {
    return [document.getElementById('m-pdp-sticky-atc'),
            document.querySelector('.m-cartpage__sticky-mobile')].filter(Boolean);
  }
  function isShown(el) {
    if (el.id === 'm-pdp-sticky-atc' && !el.classList.contains('is-visible')) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.position !== 'fixed') return false;
    return el.offsetHeight > 0;
  }
  var raf = 0;
  function update() {
    raf = 0;
    var h = 0;
    if (mq.matches) bars().forEach(function (el) { if (isShown(el)) h = Math.max(h, el.offsetHeight); });
    root.style.setProperty('--m-bottom-bar-h', h + 'px');
    root.classList.toggle('m-bottom-bar-on', h > 0);
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(update); }

  function syncStickySize() {
    var sel = document.querySelector('[data-sticky-size]');
    var form = document.getElementById('m-pdp-form');
    if (!sel || !form) return;
    var groups = form.querySelectorAll('.m-pdp__option');
    if (groups.length !== 1) return;            /* solo productos de 1 opción (talla) */
    var group = groups[0];
    var radios = group.querySelectorAll('input[type="radio"]');
    function labelOf(opt) { return (opt.textContent || '').split(' - ')[0].trim(); }

    /* placeholder "Talla" hasta que el cliente elija (antes salía "S" preseleccionada) */
    if (group.dataset.userPicked !== '1' && !sel.querySelector('option[data-m-ph]')) {
      var ph = document.createElement('option');
      ph.value = ''; ph.textContent = 'Talla'; ph.disabled = true; ph.setAttribute('data-m-ph', '1');
      sel.insertBefore(ph, sel.firstChild);
      sel.selectedIndex = 0;
    }
    /* barra → chips de la ficha (la lógica propia del tema habilita el botón) */
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      if (!opt || !opt.value) return;
      var val = labelOf(opt);
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value.trim() === val) {
          var lab = radios[i].closest('label');
          if (lab && lab.classList.contains('is-disabled')) return;
          if (radios[i].checked && group.dataset.userPicked === '1') return;
          /* 1º: evento change (no mueve la página) */
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          var atc = document.getElementById('m-pdp-atc');
          if (atc && atc.disabled) {
            /* 2º: clic real en el chip, conservando la posición de scroll */
            var y = window.scrollY;
            (lab || radios[i]).click();
            window.scrollTo(0, y);
          }
          return;
        }
      }
    });
    /* chips de la ficha → barra */
    group.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value && labelOf(sel.options[i]) === t.value.trim()) { sel.selectedIndex = i; break; }
      }
      var p = sel.querySelector('option[data-m-ph]');
      if (p) p.remove();
    });
  }

  function init() {
    update();
    syncStickySize();
    var mo = new MutationObserver(schedule);
    bars().forEach(function (el) {
      mo.observe(el, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
      if (window.ResizeObserver) new ResizeObserver(schedule).observe(el);
    });
    window.addEventListener('resize', schedule, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();